import React from 'react'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import QwasarImage from '@/images/info-qwasar.png'
import Image from 'next/image'

const InfoQwasar = () => {
    const { t } = useTranslation()
    return (
        <div className="max-w-[90%] mx-auto mb-[80px] lg:mb-[200px]">
            <div className="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12">
                <div className="flex flex-col gap-[12px] lg:gap-[32px] w-full lg:w-[60%]">
                    <p className="text-[16px] lg:text-[28px] font-[500] leading-relaxed text-[#222]">
                        <span dangerouslySetInnerHTML={{ __html: t("methodology-page.hero-slide-down-section") }} />
                    </p>

                    <Link href="/qwasar">
                        <button className="flex h-[48px] md:h-[56px] w-full sm:w-[300px] items-center justify-center border border-main-pink rounded-full bg-main-pink px-[24px] text-[16px] font-[500] text-white transition duration-300 hover:!bg-white hover:!text-main-pink">
                            {t("methodology-page.hero-slide-down-button")}
                        </button>
                    </Link>
                </div>
                <div className="w-full lg:w-[45%] xl:w-[35%] flex items-center justify-center">
                    <Image src={QwasarImage} alt="Qwasar" width={500} height={500} />
                </div>
            </div>
        </div>
    )
}

export default InfoQwasar
